import React, { HTMLProps } from 'react';

import './ui-textarea.scss';

interface UiTextareaProps extends HTMLProps<HTMLTextAreaElement> {
  noResize?: boolean;
}

const UiTextarea: React.FC<UiTextareaProps> = ({ noResize, ...props }) => (
  <textarea className="textarea" {...props} />
);

export default UiTextarea;
